import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.js';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';
import {
  ItemCard,
  ItemCardBody,
  ItemCardMeta,
  ItemCardSection,
  ItemCardSummary,
} from '@sola/ark-core/molecules/item-card/item-card.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { useAuth } from '@sola/auth-sdk/store.js';
import '@sola/locales/formatters.js';
import { TaxReceipt } from '@sola/schema/dotcom/proxy-api/taxReceipts.js';

import { CommitmentAvatarWrapper } from '../../atoms/commitment-avatar/commitment-avatar';

export type TaxReceiptCardProps =
  | {
      isLoading: true;
      taxReceipt?: TaxReceipt;
    }
  | {
      isLoading?: false;
      taxReceipt: TaxReceipt;
    };

/**
 * Tax Receipt card
 */
export const TaxReceiptCard: React.FC<TaxReceiptCardProps> = ({
  isLoading,
  taxReceipt,
}) => {
  const { t } = useTranslation('my');
  const { authUser } = useAuth('authUser');

  return (
    <>
      {isLoading && <Skeleton height={100} />}

      {!isLoading && (
        <ItemCard>
          <ItemCardSection>
            <ItemCardBody>
              <ItemCardSummary
                icon={
                  <CommitmentAvatarWrapper responsive>
                    <ArkIcon iconName="receipt-check" />
                  </CommitmentAvatarWrapper>
                }
                title={t('taxReceipts.cardTitle', { year: taxReceipt?.year })}
              />
              <ItemCardMeta
                badge={
                  <ButtonStyle
                    iconAfter={<ArkIcon iconName="download-01" />}
                    variant="secondary"
                    size="md"
                  >
                    <button
                      type="button"
                      onClick={() => {
                        // NOTE this should never happen, do we need a user error?
                        if (!authUser?.authUserGlobalId || !taxReceipt?.year) {
                          return;
                        }

                        const supporterId = encodeURIComponent(
                          authUser.authUserGlobalId,
                        );
                        const taxReceiptYear = encodeURIComponent(
                          taxReceipt.year.toString(),
                        );
                        const taxReceiptUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PROXY_API}/supporters/${supporterId}/tax-receipts/${taxReceiptYear}`;

                        window.open(
                          taxReceiptUrl,
                          '_blank',
                          'noopener,noreferrer',
                        );
                      }}
                    >
                      {t('taxReceipts.download')}
                    </button>
                  </ButtonStyle>
                }
              />
            </ItemCardBody>
          </ItemCardSection>
        </ItemCard>
      )}
    </>
  );
};
